module.exports = __webpack_public_path__ + "01_long_beige.ceac328c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_long_beige.png
// module id = 2Mwm
// module chunks = 0